const initialState = {
    responsePromotionsList: [],
    responsePromotion: [],
    responsePromotionProduct: null,
    responsePromotionProductOffices: null,
    responseDeleteProduct: null,
    errorDeleteProduct: false,
    finalPromo: false,
    responseDeletePromotionProductOffice: null,
    responsePromotionOfficeProduct: [],
    responseValidationPromotionOfficeProduct: [],
    responseHashExportPromotions: [],
    errorHashExportPromotions: false,
    responseCheckReportPromotions: [],
    errorCheckReportPromotions: false,
    batchUpdateResponse: null,
    errorBatchUpdate: false,
    promotionByIdResponse: null,
    promotionByIdError: false,
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "PROMOTIONS_RESPONSE_LIST":
            if (action.value.detail !== undefined)
                newState.responsePromotionsList = []
            else
                newState.responsePromotionsList = action.value;
            newState.responsePromotion = []
            break;

        case "PROMOTION_RESPONSE":
            newState.responsePromotion = action.value;
            break;

        case "PROMOTION_PRODUCT_RESPONSE":
            newState.responsePromotionProduct = action.value;
            break;

        case "PROMOTION_PRODUCT_OFFICES_RESPONSE":
            newState.responsePromotionProductOffices = action.value;
            newState.responsePromotion = [];
            newState.finalPromo = action.final;
            break;

        case "PRODUCT_OFFICES_RESPONSE":
            newState.responsePromotionProductOffices = action.value
            break;

        case "DELETE_PRODUCT_PROMOTION_RESPONSE":
            newState.responseDeleteProduct = action.value

            if (action.value.detail !== undefined || action.value.status >= 300) { // agrega condicion para validar que se trata de un error
                newState.errorDeleteProduct = true
            }
            break;

        case "DELETE_PRODUCT_PROMOTION_OFFICE_RESPONSE": // Setea el campo de error al borrar producto
            newState.responseDeletePromotionProductOffice = action.value

            if (action.value.detail !== undefined || action.value.status >= 300) { // agrega condicion para validar que se trata de un error
                newState.errorDeleteProduct = true
            }
            else {
            }
            break;

        case "PROMOTION_PRODUCT_OFFICE_RESPONSE": // Setea el campo de error al borrar producto
            if (action.value.detail !== undefined)
                newState.responsePromotionOfficeProduct = []
            else
                newState.responsePromotionOfficeProduct = action.value;
            break;
        case "VALIDATION_PROMOTION_PRODUCT_OFFICE_RESPONSE": // Setea el campo de error al borrar producto
            if (action.value.detail !== undefined)
                newState.responseValidationPromotionOfficeProduct = []
            else
                newState.responseValidationPromotionOfficeProduct = action.value;
            break;
        case 'HASH_EXPORT_PROMOTIONS_RESPONSE':
            newState.responseHashExportPromotions = action.value;
            if (action.value.detail !== undefined) {
                newState.errorHashExportPromotions = true;
            } else {
                newState.errorHashExportPromotions = false;
            }
            break;
        case 'REPORT_EXPORT_PROMOTIONS_RESPONSE':
            newState.responseCheckReportPromotions = action.value;
            if (action.value.detail !== undefined) {
                newState.errorCheckReportPromotions = true;
            } else {
                newState.errorCheckReportPromotions = false;
            }
            break;
        case "PROMOTION_BY_ID_RESPONSE":
            return {
                ...state,
                promotionByIdResponse: action.value,
                promotionByIdError: !!action.error,
            };

        case "BATCH_UPDATE_RESPONSE":
            return {
                ...state,
                batchUpdateResponse: action.value,
                errorBatchUpdate: !!action.error
            };

        default:
            return newState;

    }

    return newState;
};

export default reducer;